import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { __t } from '../../../i18n/t';
import { daysRangeLabel, segmentLabel } from './labels';

// Parâmetros escolhidos na criação (a campanha não se edita depois) — pedido do Emílio (15/10):
// a tela não mostrava, por exemplo, há quantos dias sem abastecer o público foi montado.
// Fonte: `audience`, `tags`, `sendPush`/`sendSms`, `notificationTime`, `maxTotalSpend` do
// GET /customer-recovery-rules/{id}.

const Item: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Box sx={{ typography: 'body2', fontWeight: 500 }}>{children}</Box>
  </Box>
);

const CampaignSetup: React.FC<{ campaign: any }> = ({ campaign }) => {
  const audience = campaign.audience;
  if (!audience || audience.minDaysWithoutFueling == null) return null;

  const tags: Array<{ id: string; name: string; color?: string }> = campaign.tags || [];

  return (
    <Stack direction="row" spacing={4} useFlexGap flexWrap="wrap" rowGap={1.5} mt={2}>
      <Item label="Segmento">{segmentLabel(audience.segment)}</Item>
      <Item label="Sem abastecer há">{daysRangeLabel(audience.minDaysWithoutFueling, audience.maxDaysWithoutFueling)}</Item>
      <Item label="Quem nunca abasteceu">{audience.includeNeverFueled ? __t('Incluído') : __t('Fora')}</Item>
      <Item label="Etiquetas">
        {tags.length ? (
          <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
            {tags.map((t) => (
              <Chip key={t.id} size="small" variant="outlined" label={t.name} sx={t.color ? { borderColor: t.color } : undefined} />
            ))}
          </Stack>
        ) : __t('Todas')}
      </Item>
      <Item label="Limite de clientes">
        {audience.maxCustomers != null ? Number(audience.maxCustomers).toLocaleString('pt-BR') : __t('Sem limite')}
      </Item>
      <Item label="Canais">
        {[campaign.sendPush && 'Push', campaign.sendSms && 'SMS'].filter(Boolean).join(' + ') || __t('Nenhum')}
      </Item>
      {(campaign.sendPush || campaign.sendSms) && (
        <Item label="Horário do envio">
          {campaign.notificationTime ? String(campaign.notificationTime).slice(0, 5) : __t('Assim que o nível começa')}
        </Item>
      )}
      <Item label="Teto de gasto">
        {campaign.maxTotalSpend != null
          ? `R$ ${Number(campaign.maxTotalSpend).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
          : __t('Sem teto')}
      </Item>
    </Stack>
  );
};

export default CampaignSetup;
